module.exports = __webpack_public_path__ + "img/caratula_elcantodelacalle.00eed149.jpg";